/* eslint-disable implicit-arrow-linebreak */
import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router';
import AuthGuard from './components/AuthGuard';
import GuestGuard from './components/GuestGuard';
import LoadingScreen from './components/LoadingScreen';
import DashboardLayout from './components/dashboard/DashboardLayout';
import HelpLayout from './components/dashboard/HelpLayout';
import ProjectSection from './components/organization/projects/ProjectSection';
import CasesViewByProjects from './components/organization/projects/cases/CasesViewByProjects';
import Account from './pages/Account';
import EditCases from './pages/cases/EditCases';
import UnApprovedCases from './pages/cases/UnApprovedCases';
import OpenCases from './pages/cases/openCases';
import BackLogCases from './pages/cases/BackLog';

import ViewCases from './pages/cases/ViewCases';
import ContactsListView from './pages/contacts/listView';
import Overview from './pages/dashboard/Overview';
import Contacts from './pages/help/Contacts';
import Dashboard from './pages/help/Dashboard';
import Introduction from './pages/help/Introduction';
import Project from './pages/help/Project';
import HelpCases from './pages/help/cases/HelpCases';
import HelpCreateCases from './pages/help/cases/HelpCreateCases';
import HelpViewCases from './pages/help/cases/HelpViewCases';
import ViewReporting from './pages/reporting/ViewReporting';
import PermissionGuard from './components/PermissionGuard';

import {
  APPROVALS,
  CLIENT_CASES,
  CLIENT_PROJECTS,
  CLIENT_USERS,
  REPORTING,
  // TESTING,
} from 'src/constants/constants';
// import OrdersListView from './pages/oms/orders/ListView';
// import InvoicesListView from './pages/oms/invoices/ListView';
// import SingleInvoiceView from './pages/oms/invoices/SingleInvoiceView';
import TwoFactorAuthentication from './pages/authentication/TwoFactorAuthentication';
import TwoFactorAuthGuard from './components/TwoFactorAuthGuard';
import TestingCases from './pages/cases/TestingCases';
import { ChatsHistory } from './components/chat/ChatHistory';
import Planning from './pages/planning/planning';

const Loadable = (Component) => (props) =>
(
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

const CreateCasesWizard = Loadable(
  lazy(() => import('./components/cases/CreateCasesWizard'))
);
// const ContactsListView = Loadable(
//   lazy(() => import('./pages/contacts/listView'))
// );
const EditContacts = Loadable(lazy(() => import('./pages/contacts/edit')));
const Login = Loadable(lazy(() => import('./pages/authentication/Login')));
const PasswordRecovery = Loadable(
  lazy(() => import('./pages/authentication/PasswordRecovery'))
);
const PasswordReset = Loadable(
  lazy(() => import('./pages/authentication/PasswordReset'))
);
const AuthorizationRequired = Loadable(
  lazy(() => import('./pages/AuthorizationRequired'))
);
const NotFound = Loadable(lazy(() => import('./pages/NotFound')));
const ServerError = Loadable(lazy(() => import('./pages/ServerError')));

// eslint-disable-next-line import/no-mutable-exports
let routes: any[] = [];

routes = [
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      // ---> Dashboard
      {
        index: true,
        element: <Navigate to="cases/dashboard" />,
      },
      // {
      //   path: 'dashboard',
      //   element: <Overview />,
      // },
      {
        path: 'dashboard',
        element: <Navigate to="/cases/dashboard" replace />,
      },
      // ---> Analytics
      // {
      //   path: 'analytics',
      //   element: <Analytics />,
      // },
      // ---> Contacts
      {
        path: 'contacts',
        element: (
          <PermissionGuard hasPermission={CLIENT_USERS}>
            <ContactsListView />
          </PermissionGuard>
        ),
      },
      {
        path: 'contacts/edit/:id',
        element: (
          <PermissionGuard hasPermission={CLIENT_USERS}>
            <EditContacts />
          </PermissionGuard>
        ),
      },
      // ---> Reporting
      // {
      //   path: 'reporting',
      //   element: <Reporting />,
      // },
      // ---> Settings
      // {
      //   path: 'settings',
      //   element: <Settings />,
      // },
      // ---> Account
      {
        path: 'account',
        element: <Account />,
      },
      {
        path: 'chats-history',
        element: <ChatsHistory />,
      },
      // ---> Projects
      {
        path: 'projects',
        element: (
          <PermissionGuard hasPermission={CLIENT_PROJECTS}>
            <ProjectSection />
          </PermissionGuard>
        ),
      },
      // Add these routes after the existing project route
      {
        path: 'projects/:projectID/all',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <ViewCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'projects/:projectID/open',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <OpenCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'projects/:projectID/approvals',
        element: (
          <PermissionGuard hasPermission={APPROVALS}>
            <UnApprovedCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'projects/:projectID/backlog',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <BackLogCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'projects/:projectID/testing',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <TestingCases />
          </PermissionGuard>
        ),
      },
      // ---> Billable Reportings
      {
        path: 'reporting',
        element: (
          <PermissionGuard hasPermission={REPORTING}>
            <ViewReporting />
          </PermissionGuard>
        ),
      },
      {
        path: 'planning',
        element: (
          <PermissionGuard hasPermission={REPORTING}>
            <Planning />
          </PermissionGuard>
        ),
      },
      // {
      //   path: 'oms',
      //   element: (
      //     <Navigate to="/oms/orders" />
      //   ),
      // },
      // {
      //   path: 'oms/orders',
      //   element: (
      //     // <PermissionGuard hasPermission={REPORTING}>
      //     <OrdersListView />
      //     // </PermissionGuard>
      //   ),
      // },
      // {
      //   path: 'oms/invoices',
      //   element: (
      //     // <PermissionGuard hasPermission={REPORTING}>
      //     <InvoicesListView />
      //     // </PermissionGuard>
      //   ),
      // },
      // {
      //   path: 'oms/invoices/:invoiceID',
      //   element: (
      //     // <PermissionGuard hasPermission={REPORTING}>
      //     <SingleInvoiceView />
      //     // </PermissionGuard>
      //   ),
      // },
      {
        path: 'projects/:projectID',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <CasesViewByProjects />
          </PermissionGuard>
        ),
        // children: [
        //   {
        //     // index: true,
        //     path: 'cases',
        //     element: <CasesViewByProjects />,
        //   },
        //   {
        //     path: 'cases/add',
        //     element: <CreateCasesWizardProject />,
        //   },
        //   {
        //     path: 'cases/:caseID',
        //     element: <EditCases orgEditComponent />,
        //   },
        // ],
      },
      // ---> Cases
      {
        path: 'cases/all',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <ViewCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/approvals',
        element: (
          <PermissionGuard hasPermission={APPROVALS}>
            <UnApprovedCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/backlog',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <BackLogCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/testing',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <TestingCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/open',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <OpenCases />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/dashboard',
        element: <Overview />,
      },

      {
        path: 'cases/add',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <CreateCasesWizard />
          </PermissionGuard>
        ),
      },
      {
        path: 'cases/:caseID',
        element: (
          <PermissionGuard hasPermission={CLIENT_CASES}>
            <EditCases />
          </PermissionGuard>
        ),
      },
    ],
  },
  {
    path: 'help',
    element: (
      <AuthGuard>
        <HelpLayout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Introduction />,
      },
      {
        path: 'dashboard',
        element: <Dashboard />,
      },

      {
        path: 'project',
        element: <Project />,
      },
      {
        path: 'contacts',
        element: <Contacts />,
      },
      // {
      //   path: 'multi-lang-support',
      //   element: <MultiLangSupport />,
      // },
      {
        path: 'cases',
        children: [
          {
            index: true,
            element: <HelpCases />,
          },
          {
            path: 'create',
            element: <HelpCreateCases />,
          },
          {
            path: 'view',
            element: <HelpViewCases />,
          },
        ],
      },
    ],
  },

  // ---> Others
  {
    path: '*',
    children: [
      {
        path: 'login',
        element: (
          <GuestGuard>
            <Login />
          </GuestGuard>
        ),
      },
      {
        path: 'login/two-factor-authentication',
        element: (
          <TwoFactorAuthGuard>
            <TwoFactorAuthentication />
          </TwoFactorAuthGuard>
        ),
      },
      {
        path: 'forgot-password',
        element: <PasswordRecovery />,
      },
      {
        path: 'reset-password',
        element: <PasswordReset />,
      },
      {
        path: '401',
        element: <AuthorizationRequired />,
      },
      {
        path: '404',
        element: <NotFound />,
      },
      {
        path: '500',
        element: <ServerError />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

export default routes;
